"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _FilterPanelSection.default;
  }
});

var _FilterPanelSection = _interopRequireDefault(require("./FilterPanelSection"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }